import { connect } from 'react-redux';
import { get } from 'lodash';
import ReturnsSummary, {
  ReturnsSummaryProps,
} from '@/components/DeprecatedPortfolio/components/ReturnsSummary';
import {
  portfolioSummarySelector,
  hasHoldingsInDifferentCurrencies,
} from '@/components/DeprecatedPortfolio/redux/selectors';

const getter = (obj) => (property, defaultValue) =>
  get(obj, property, defaultValue);

const makeMapStateToProps = () => {
  const mapStateToProps = (state): ReturnsSummaryProps => {
    const portfolioSummary = portfolioSummarySelector(state);
    const summaryGetter = getter(portfolioSummary);
    return {
      isWatchlist: summaryGetter('isWatchlist', false),
      portfolioWithNoTransactions: summaryGetter(
        'portfolioWithNoTransactions',
        false
      ),
      totalReturn: summaryGetter('totalReturn', 0),
      dividendReturn: summaryGetter('dividendReturn', 0),
      currencyReturn: summaryGetter('currencyReturn', null),
      currencyReturnFormatted: summaryGetter('currencyReturnFormatted', '0'),
      currencyGainFormatted: summaryGetter('currencyGainFormatted', '0'),
      totalGainFormatted: summaryGetter('totalGainFormatted', 0),
      totalDividendReturn: summaryGetter('totalDividendReturn', 0),
      capitalGainFormatted: summaryGetter('capitalGainFormatted', '0'),
      totalReturnFormatted: summaryGetter('totalReturnFormatted', '0'),
      dividendGainFormatted: summaryGetter('dividendGainFormatted', '0'),
      dividendReturnFormatted: summaryGetter('dividendReturnFormatted', '0'),
      totalDividendReturnFormatted: summaryGetter(
        'totalDividendReturnFormatted',
        '0'
      ),
      hasHoldingsInDifferentCurrencies: hasHoldingsInDifferentCurrencies(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(ReturnsSummary);
